<template>
  <div class="home">
    <div class="home-container">
      <div
        class="home-item"
        v-for="(item, index) in themeList"
        :key="item.id"
        :class="sendBackBgColor(index)"
      >
        <div
          class="home-item_content"
          :class="index % 2 !== 0 ? 'flex-row-reverse' : ''"
        >
          <el-image :src="item.icon" class="home-item_icon">
            <div slot="error">
              <img
                style="width: 100%; height: 100%"
                src="@/assets/picture01.png"
                alt=""
              />
            </div>
          </el-image>

          <div class="home-item_des">
            <h1>{{ $i18n.tObject(item._info, "name") }}</h1>
            <!--展覽概況需要渲染html -->
            <p
              v-if="item.id === 0"
              v-html="$i18n.tObject(item._info, 'summary')"
            ></p>
            <p v-else>{{ $i18n.tObject(item._info, "summary") }}</p>
            <el-button
              class="el-button_bg_transparent"
              round
              @click="onShowDetailClick(item)"
              >{{ $t("showMore") }} ></el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { context } from "@/api/config";
export default {
  name: "Home",
  data() {
    return {
      // 主題列表
      themeList: [
        {
          id: 0,
          _info: {
            name: "展覽概況",
            namePt: "Visão Geral da Exposição",
            nameEn: "展覽概況en",
            summary: "",
            summaryPt: "",
            summaryEn: "",
          },
          path: "/introduction",
          icon: require("@/assets/picture01.png"),
        },
        // {
        //   id: 6,
        //   _info: {
        //     name: "論壇報名",
        //     namePt: "Forúm e inscrição",
        //     summary:
        //       "舉辦“探索科技創新創業之路”及“企業如何配合橫琴粵澳深度合作區戰略發展”兩場論壇。",
        //     summaryPt:
        //       "ealizam-se dois fóruns de tópicos “Explorar o Caminho da Inovação Científica e Tecnológica e do Empreendedorismo” e “Como as Empresas Cooperam com o Desenvolvimento Estratégico da Zona de Cooperação Aprofundada entre Guangdong e Macau em Hengqin”.",
        //   },
        //   path: "/forum-sign",
        //   icon: require("@/assets/picture06.png"),
        // },
        {
          id: 7,
          _info: {
            name: "活動時間表",
            namePt: "Programa das Actividades",
            nameEn: "活動時間表en",
            summary:
              "是次展覽內容豐富，除了展出本澳科創企業及科研機構的科技成果外，還有多項科普活動、論壇、工作坊等項目。",
            summaryPt:
              "O conteúdo do evento é muito rico. Além de exibir as realizações científicas e tecnológicas de empresas de inovação científica e tecnológica e instituições de investigação científica de Macau, estabelecem-se também vários eventos como actividades de popularização científica, fóruns, oficinas e entre outros.",
            summaryEn: "en",
          },
          path: "/activity-time",
          icon: require("@/assets/picture07.png"),
        },
      ],
    };
  },
  watch: {
    isRouterChange: {
      handler: function (v) {
        if (v) {
          this.setThemeList();
          this.changeBaseThemeList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      isRouterChange: (state) => state.isRouterChange,
      activityDetail: (state) => state.activityDetail,
    }),
  },
  mounted() {},
  created() {},
  methods: {
    // 设置主题列表
    setThemeList() {
      // 獲取動態添加的路由
      const addRoute = this.$router
        .getRoutes()
        .filter((item) => item.meta.mode);
      const addThemeList = addRoute.map((i) => {
        return {
          id: i.meta.id,
          icon:
            i.meta.displayMode !== undefined
              ? `${context}/public/api/v1/website/boothsAreaCategory/icon?boothsAreaCategoryId=${i.meta.id}`
              : `${context}/public/api/v1/website/websiteExhibitionArea/icon?areaId=${i.meta.id}`,
          path: i.path,
          _info: i.meta,
        };
      });
      this.themeList.splice(1, 0, ...addThemeList);
    },
    // 更改基礎列表的值
    changeBaseThemeList() {
      this.themeList[0]._info.summary = this.activityDetail.summary;
      this.themeList[0]._info.summaryPt = this.activityDetail.summaryPt;
      this.themeList[0]._info.summaryEn = this.activityDetail.summaryEn;
    },
    onShowDetailClick(item) {
      if (item.path) {
        this.$router.push({ path: item.path, query: item.query });
      }
    },
    sendBackBgColor(i) {
      if (i % 2 === 0) return "shallow_purple";
      if (i % 3 === 0) return "shallow_white";
      return "shallow_green";
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  &-item {
    &.shallow_purple {
      background-color: #e8eaff;
    }
    &.shallow_white {
      background-color: #ffffff;
    }
    &.shallow_green {
      background-color: #f3f9fe;
    }
  }
  &-item_content {
    padding: 14px 0 30px 0;
    height: 100%;
    width: calc(100% - 28px);
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    &.flex-row-reverse {
      flex-direction: row-reverse;
      .home-item_icon {
        margin-left: 0;
        margin-right: 10px;
      }
      .home-item_des {
        margin-left: 0;
        margin-right: 8%;
      }
    }
  }
  &-item_icon {
    height: 36%;
    width: 33%;
    max-width: 364px;
    max-height: 340px;
    margin-top: 14px;
    margin-left: 10px;
  }
  &-item_des {
    width: 55%;
    margin-left: 8%;
    h1 {
      font-size: 45px;
      color: #24252b;
      margin-bottom: 20px;
    }
    p {
      font-size: 17.5px;
    }
  }
}
::v-deep .el-button_bg_transparent {
  &.el-button {
    background-color: transparent;
    border-color: rgba(122, 122, 123, 0.8);
    color: rgba(122, 122, 123, 0.8);
    &:hover,
    &:focus {
      border-color: #7a7a7b;
      color: #7a7a7b;
    }
  }
}
@media screen and (max-width: 767px) {
  .home-item_des {
    h1 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
  }
}
</style>
